import { Box } from '@mui/material';
import { useListContext } from 'framework/list';
import { useShowContext } from 'framework/show';
import { POSITION_SLOT_STATUS } from '../constants';
import ConfirmPositionSlotButton from './ConfirmPositionSlotButton';
import ArchivePositionSlotButton from './ArchivePositionSlotButton';
import UpdatePositionSlotModalButton from './UpdatePositionSlotModalButton';

const PositionSlotActionsButton = () => {
  const { data } = useShowContext();
  const { reloadData = () => {} } = useListContext();
  const { id, status, employeeAlias } = data.getData();
  const onSuccess = () => reloadData();

  if (status === POSITION_SLOT_STATUS.ARCHIVED) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, alignItems: 'center' }}>
      <ConfirmPositionSlotButton />
      <UpdatePositionSlotModalButton onSuccess={onSuccess} />
      <ArchivePositionSlotButton positionSlotId={id} employeeAlias={employeeAlias} onSuccess={onSuccess} />
    </Box>
  );
};

export default PositionSlotActionsButton;
